<div class="banner-reviews wrap">
    <!-- banner reviews -->
    <div class="w-12 bg-col-5 center p-t-8 p-b-8 m-b-8">
        <div class="m-b-2 m-b-2-s flex flex-justify-center flex-middle flex-wrap-s">
            @if (component.image) {
            <div class="w-1 w-2-m w-5-s m-r-2">
                <img class="w-12"
                     [dfImage]="component.image"
                     [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                     ratio="3/1">
            </div>
            }
            <div class="w-12-s">
                <span class="h2">
                    <span *ifSize="'!S'">|</span>
                    <span class="m-l-1 m-l-0-s">{{ratingText}}</span>
                </span>
                <rating class="h2 m-l-2"
                        [value]="rating" />
            </div>
        </div>
        @if (app.data.reviews.reviews_count) {
        <div class="h2 m-t-4-s m-b-4-s">
            <span class="p-r-1">{{app.data.reviews.reviews_count | number}}</span>
            {{'reviews' | translate}}
        </div>
        }
    </div>
    <!-- text -->
    <span class="w-12 center h1"
          [ngClass]="component.copy ? 'm-b-1' : 'm-b-2'"
          *iCms="'title' of component; content: 'html'; skipEmpty: true"></span>
    <span class="w-12 center p1 m-b-2"
          *iCms="'copy' of component; content: 'html'; skipEmpty: true"></span>
    <all-reviews />
</div>
